<template>
  <div>
    <div class="page" :class="{'ratio': devicePixelRatio === 2}">
      <div class="block bar m_container">
        <div class="block_box">
          <div class="bar_content">
            <div class="product">
              <div class="item">
                <img src="../assets/care/logo.png" alt="">
              </div>
              <div class="item">
                <p>CareMoney</p>
                <p>An Instant Loan App</p>
              </div>
            </div>
            <div class="title">EXQUISITE SHOWERS LIMITED</div>
            <div class="hint">
              CareMoney is a financial loan service provided by EXQUISITE SHOWERS LIMITED. It is licensed and regulated by the Federal Competition & Consumer Protection Commission (FCCPC) of Nigeria.</div>
          </div>
          <div class="tips">
            <p>Licensed and regulated by the FCCPC of Nigeria.</p>
            <img src="../assets/img/fccpc.png" alt="">
          </div>
        </div>
      </div>
      <div class="about">
        <div class="about_title">About Us</div>
        <div class="about_items">
          <div class="about_item">
            <div class="title">
              <p>Our Vision</p>
            </div>
            <p>EXQUISITE SHOWERS LIMITED is building an excellent online inclusive financial platform for emerging markets.</p>
            <p>We are supervised by local financial institutions in Nigeria. We have established a complete risk management system and user data protection mechanism. We uphold the principles of fairness and integrity, ensure that all products are legal and compliant, and protect the safety of user funds.</p>
            <div class="title">
              <p>What We Are</p>
            </div>
            <div class="line"></div>
            <p class="text">We built a smart, credit-led digital lending platform: making people’s lives easier when they need a loan to fund their business or for personal reasons, without collateral. Most Nigerian groups do not have access to loan services from traditional banks, so we provide inclusive lending to their various needs to help them thrive.</p>
          </div>
          <img class="about_item" src="../assets/img/about.jpg" alt="">
        </div>
      </div>
    </div>
    <my-footer class="footer" />
  </div>
</template>

<script>
import MyFooter from '@/components/Footer.vue';

export default {
  name: 'Home',
  data() {
    return {
      devicePixelRatio: window.devicePixelRatio,
    };
  },
  components: {
    MyFooter,
  },
};
</script>

<style lang="scss" scoped>
@mixin pixel-ratio() {}

.page {
  @include pixel-ratio();
  text-align: center;
  padding-bottom: 30px;
  .ratio {
  }
  /deep/ .el-carousel__indicators {
    .el-carousel__indicator {
      .el-carousel__button {
        width: 5px;
        height: 5px;
        border-radius: 5px;
        background-color: white;
      }
    }
    .is-active .el-carousel__button {
      background-color: #333333;
    }
  }
  .m_container{
    background: #FBF9F9;
    // margin-top: -30px;
  }
  .about {
    .about_title {
      margin: 30px 0;
      font-size: 30px;
      font-weight: 800;
    }
    .about_items{
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin: 0 100px;
      img{
        width: 500px;
      }
      .about_item {
        text-align: left;
        .title {
          display: flex;
          flex-direction: row;
          justify-content: left;
          align-items: center;
          p {
            font-size: 20px;
            font-weight: 800;
            // color: #FFFFFF;
            background-color: #f4d66e;
            border-radius: 10px;
            padding: 6px 8px;
          }
        }
        p {
          font-size: 18px;
          line-height: 20px;
          margin-top: 20px;
        }
      }
    }
  }


  .block {
    text-align: center;
    .block_box {
      // display: flex;
    }
    .bar_content {
      text-align: center;
    }
    .product{
      display: flex;
      flex-direction: row;
      justify-content: center;
      width: 300px;
      text-align: center;
      margin: 0 auto;
      padding-top: 20px;
      .item {
        text-align: left;
        height: 60px;
        margin-right: 10px;
        img {
          height: 60px;
        }
        p {
          line-height: 5px;
          font-size: 14px;
          &:first-child {
            font-size: 18px;
            font-weight: 800;
          }
        }
      }
    }
    .title {
      margin-top: 10px;
      font-size: 12px;
      font-weight: 700;
      color: #999999;
    }
    .text {
      font-size: 14px;
      color: #333333;
      padding: 10px 0px;
    }
    .hint {
     font-size: 13px;
      font-weight: 600;
     // color: #999999;
     width: 660px;
     margin: 10px auto;
    }
    .tips{
      padding-bottom: 10px;
      p {
        font-size: 20px;
        font-weight: 800;
      }
      img {
        height: 80px;
      }
    }
    .el-button {
      margin-top: 30px;
    }
    &_box {
      max-width: 1200px;
      margin: 0 auto;
    }
    &.bar {
      // background: #FBF9F9;
      .block_box {
        position: relative;
      }
      .bar_img {
        background-size: contain;
        background-repeat: no-repeat;
        background-position: right;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 0;
      }
    }
    &.apply {
      background: white;
      margin-top: 64px;
      .apply_content {
        padding: 10px;
        // background-color: #F5F5F5;
        padding-left: 80px;
        padding-right: 80px;
        padding-top: 55px;
        flex: 1;
      }
      .apply_img {
        min-width: 310px;
        background-size: 100%;
        background-repeat: no-repeat;
      }
    }
    &.prompt {
      margin-top: 40px;
      .block_box {
        padding: 10px;
      }
    }
    &.over {
      margin-top: 64px;
      .over_content {
        padding: 10px;
        padding-top: 55px;
        flex: 1;
      }
      .over_img {
        width: 295px;
        height: 295px;
        background-size: 100%;
        background-repeat: no-repeat;
        text-align: center;
        position: relative;
        >div {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
          font-size: 21px;
          span {
            font-size: 14px;
            color: #F0ECF5;
          }
          div {
            font-size: 47px;
            font-weight: bold;
          }
        }
      }
    }
    &.ready {
      margin-top: 64px;
      margin-bottom: 64px;
      .ready_content {
        padding: 10px;
        padding-top: 55px;
        flex: 1;
        text-align: right;
      }
      .ready_img {
        max-width: 396px;
        img {
          width: 100%;
        }
      }
    }
  }

  .block1 {
    text-align: left;
    .title {
      font-size: 32px;
      font-weight: 700;
      color: #333333;
    }
    .text {
      font-size: 14px;
      color: #333333;
      padding: 10px 0px;
    }
    .hint {
      font-size: 13px;
      color: #333333;
      padding: 10px 0px;
    }
    .line {
      height: 0.5px;
      // background: #CCCCCC;
    }
    .el-button {
      margin-top: 30px;
    }
    &_box {
      max-width: 1200px;
      margin: 0 auto;
    }
    &.bar {
      position: relative;
      background: white;
      .bar_img {
        width: 100%;
        img {
          width: 100%;
        }
      }
      .bar_content {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        .bar_value {
          position: relative;
          top: 50%;
          transform: translateY(-50%);
          padding: 0px 10px;
          max-width: 1200px;
          margin: 0 auto;
          .hint {
            max-width: 500px;
          }
        }
      }
    }
    &.prompt {
      margin-top: 40px;
      .block_box {
        padding: 10px;
      }
    }
    &.list {
      margin-top: 40px;
      .block_box {
        padding: 10px;
      }
      .list_content {
        margin-top: 30px;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        &_item {
          background: rgba(103, 45, 158, 0.03);
          border-radius: 4px;
          display: inline-block;
          margin-bottom: 16px;
          width: 30%;
          .img {
            width: 35px !important;
            height: 35px !important;
            border-radius: 35px;
            background: rgba(103, 45, 158, 0.1);
            margin-top: 35px;
            margin: 35px 20px 10px 20px;
          }
          .text {
            padding: 0px 20px;
          }
          .hint {
            margin-top: 15px;
            margin-bottom: 30px;
            color: #333333;
            padding: 0px 20px;
          }
        }
      }
    }
    &.join {
      margin-top: 33px;
      margin-bottom: 20px;
      .block_box {
        display: flex;
      }
      .join_content {
        padding: 10px;
        padding-top: 55px;
        margin-bottom: 20px;
        flex: 1;
      }
      .join_img {
        max-width: 396px;
        font-size: 0px;
        img {
          width: 100%;
        }
      }
    }
  }

  @media screen and (max-width: 800px) {
    .block {
      text-align: center;
      .block_box {
        display: inline-block;
      }
      &.bar {
        .bar_img {
          background-size: cover;
          top: 140px;
          bottom: 120px;
        }
        .title {
          font-size: 26px;
        }
        .el-button {
          margin-top: 330px;
        }
        .bar_content {
          padding-top: 30px;
          padding-bottom: 20px;
        }
      }
      &.apply {
        .apply_content {
          background: white;
          padding-left: 10px;
          padding-right: 10px;
        }
      }
      &.over {
        .over_img {
          margin: 0 auto;
        }
        .over_content {
          float: left;
          margin-top: 290px;
        }
      }
      &.ready {
        .ready_img {
          margin: 0 auto;
        }
        .ready_content {
          padding-top: 30px;
          text-align: center;
        }
      }
    }
  }
}
</style>
